import React from 'react';
import { DebtStatusLogic } from '../../elements/DebtStatusLogic/debtStatusLogic';

export const Landing: React.FC = () => {
	return <DebtStatusLogic isDashboard={false} />;
};
